export class EntityStateModel<T> {
    fetchingItem: string[] = [];
    item: string = null;

    fetchingList = false;
    sortProperties: string[] = [];
    map: Map<string, T> = null;
}
